<template>
  <q-card flat :style="!$q.screen.lt.md?'width: 500px; max-width: 80vw;':''">
    <q-card-section class="no-padding">
      <q-banner inline-actions class="bg-blue text-white">
        <span class="text-subtitle2">{{ goodsInfo !== null ? goodsInfo.Goods_Name : groupInfo.Group_Name }}</span>
        <q-badge :label="goodsInfo!==null? goodsInfo.Goods_Code:groupInfo.Group_ID" color="red" text-color="white"
                 align="top"/>
        <template v-slot:action>
          <q-btn icon="close" flat v-close-popup round/>
        </template>
      </q-banner>
    </q-card-section>
    <q-card-section>
      <q-option-group
          :options="statesList"
          type="radio"
          v-model="selectedState"
      />
    </q-card-section>
    <q-card-actions align="center">
      <q-btn color="primary" label="تایید" text-color="white" icon="check" @click="changeState"/>
      <q-btn color="red" flat label="انصراف" icon="cancel" v-close-popup/>
    </q-card-actions>
  </q-card>
</template>

<script>
import {mapActions} from "vuex";

export default {
  name: "ChangeState",
  props: {
    goodsInfo: {
      type: Object,
    },
    groupInfo: {
      type: Object,
    }
  },
  data() {
    return {
      statesList: [],
      selectedState: null
    }
  },
  methods: {
    ...mapActions({
      changeProductState: 'Products/changeProductState',
      changeProductGroupState: 'Products/changeProductGroupState',
      getStatesList: 'Products/loadProductState'
    }),
    changeState() {
      if (this.selectedState === null) return

      if (this.groupInfo === null) {
        this.changeProductState({
          Goods_ID: this.goodsInfo.Goods_ID,
          State_ID: this.selectedState
        }).then((res) => {
          if (res.result === 1) {
            this.goodsInfo.Goods_SaleStatus = this.selectedState
            this.goodsInfo.General_Name = this.statesList.filter(item => item.value === this.selectedState)[0].label
            this.$emit('close-dialog', this.goodsInfo)
          }
        })
      } else if (this.goodsInfo === null) {
        this.changeProductGroupState({
          Group_ID: this.groupInfo.Group_ID,
          State_ID: this.selectedState
        }).then((res) => {
          if (res.result === 1) {
            this.$emit('close-dialog', this.groupInfo)
          }
        })
      }
    }
  },
  created() {
    this.getStatesList().then((res) => {
      res.forEach((record) => {
        this.statesList.push({label: record.General_Name, value: record.G_Code})
      })
      if (this.goodsInfo !== null) {
        this.selectedState = this.goodsInfo.Goods_SaleStatus
      }
    })
  }
}
</script>

<style scoped>

</style>